export default __webpack_public_path__ + "static/media/Selfielocation_devonport.fbc61538.png";